import datepicker from 'js-datepicker';
//import dateFormat from 'dateFormat';
//import Inputmask from "inputmask";
export default () => {
  let srcolldata = sessionStorage.getItem(window.location.pathname);
  window.scrollTo(0,srcolldata);
  const updateNextUI = () => {
    const products = document.querySelectorAll('li.change');
    const buttonNext = document.getElementById('next');
    if (products.length === 0) {
      buttonNext.disabled = false;
    }
  };
  const orderUpdate = (id, count) => {
    const data = new FormData();
    data.append('id', id);
    data.append('count', count);
    fetch('/order/add', {
      method: 'POST',
      body: data
    })
    .then(result => result.text())
    .then((result) => {
      const li = document.getElementById(id);
      li.classList.remove("change");
      li.style.opacity = 0.5;
      let buttons = li.querySelector('.order_buttons');
      buttons.classList.add("is-hidden");
      console.log(buttons);
      updateNextUI();
    });
  };
  const orderRemove = (id) => {
    const data = new FormData();
    data.append('id', id);
    fetch('/order/remove', {
      method: 'POST',
      body: data
    })
    .then(result => result.text())
    .then((result) => {
      const li = document.getElementById(id);
      li.classList.remove("change");
      li.style.opacity = 0.5;
      let buttons = li.querySelector('.order_buttons');
      let info = li.querySelector('.plist-item-total');
      buttons.classList.add("is-hidden");
      info.innerHTML  = '<span class="text-error">Удален</span>';
      console.log(info.lastChild);
      updateNextUI();
    });
  };
  window.orderUpdate = orderUpdate;
  window.orderRemove = orderRemove;


const isFourteenOclock = () => {
  let now = new Date();
  let tomorrow = new Date();
  let afterTomorrow = new Date();
  let dow = now.getDay();
  tomorrow.setDate(tomorrow.getDate() + 1);
  afterTomorrow.setDate(afterTomorrow.getDate() + 2);
  if (dow == 6 || dow == 0){
    return (now.getHours() < 11 ) ? now : tomorrow;
  }
  return (now.getHours() < 14 ) ? now : tomorrow;
};
const availableDate = isFourteenOclock();

const isTvelweOclock = (date) => {
  let now = new Date(Date.now());
  const firstline = document.querySelectorAll('.firstline');
  firstline.forEach((el) => el.classList.remove('is-hidden'));
  document.getElementById('0').checked = true;
  if (now.getDate() === date.getDate()) {
    let hours = Number(now.getHours());
    if (hours >= 12 && hours < 14 ) {
      firstline.forEach((el) => el.classList.add('is-hidden'));
      document.getElementById('3').checked = true;
    }
  }
};

isTvelweOclock(availableDate);

  const picker = datepicker('#order-date', {
  startDay: 1,
  customDays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  customMonths: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
  formatter: (input, date, instance) => {
    const value = date.toLocaleDateString()
    input.value = value // => '1/1/2099'
  },
  minDate: availableDate,
  dateSelected: availableDate,
  onSelect: (instance, date) => {
    isTvelweOclock(date);
  }

});


}
